import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import Toasted from 'vue-toasted'

import Loader from './components/Loader.vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

const unsync = sync(store, router)
Vue.config.productionTip = false
Vue.config.devtools = true

Vue.component('Loader', Loader)

Vue.use(Toasted, {
  theme: 'bubble',
  position: 'bottom-center',
  duration: 5000,
})

new Vue({
  router,
  store,
  render: h => h(App),
  beforeDestroy () {
    unsync()
  },
}).$mount('#app')


setTimeout(() => {
  const footer = document.getElementsByTagName('footer')
  if (footer.length && footer[0].clientHeight !== 100) {
    alert('App Update: Please refresh and close the app, then open it up again')
  }
}, 2000)
